'use client'

import React, { useContext, useEffect, useRef } from 'react'
import { PortalContext, PortalTargetId } from '../hooks/portal'

type Props = {
  id: PortalTargetId
  className?: string
}

export const PortalTarget = ({ id, className }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const { setTarget } = useContext(PortalContext)

  useEffect(() => {
    if (ref.current) {
      setTarget(id, ref.current)
    }
  }, [ref])

  return <div ref={ref} className={className}></div>
}
